import React from 'react';

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: React.ReactNode;
  fluid?: boolean;
}

export const Container: React.FC<ContainerProps> = ({ className = '', fluid = false, children, ...props }) => {
  return (
    <div className={`${fluid ? 'w-full' : 'container mx-auto'} px-4 ${className || ''}`} {...props}>
      {children}
    </div>
  );
};
